import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { replaceTokensWithComponents } from '@app/utils';
import { sms } from '../../../constant';
import styles from './CallUsMessage.module.scss';
import cx from 'classnames';

function CallUsMessage({
  isCatCorp,
  helpCenterEnabled,
  tollFreeNumber,
  phoneNumber,
  directNumber,
  localPhone
}) {
  const { t } = useTranslation();
  const countryCode = useSelector(state => state.common.userCountryCode);
  const locale = useSelector(s => s.common.locale);
  const userCountryCode = countryCode || 'US';
  const selectedStore = useSelector(state => state.common.selectedStore);

  const returnPhoneNumber = (phoneNumber, type) => {
    return (
      <a
        className={cx(styles['phone-number'], 'w-100 d-inline-block')}
        href={`${type}:${phoneNumber}`}
      >
        {phoneNumber}
      </a>
    );
  };

  const returnPhoneNumberWithTitle = (title, phoneNumber) => (
    <p className={cx(styles['phone'], 'text-center')}>
      <b>{title}: </b>

      {title === 'SMS'
        ? returnPhoneNumber(phoneNumber, 'sms')
        : returnPhoneNumber(phoneNumber, 'tel')}
    </p>
  );

  const smsNumber =
    locale === 'en_US' && returnPhoneNumberWithTitle('SMS', sms.number);

  const renderTollFreeDirectNumbers = (
    tollFreePhoneNumber,
    directPhoneNumber
  ) => (
    <>
      {returnPhoneNumberWithTitle(t('TOLL_FREE'), tollFreePhoneNumber)}
      {returnPhoneNumberWithTitle(t('DIRECT_PHONE_NUMBER'), directPhoneNumber)}
      {smsNumber}
    </>
  );

  const renderNonUSPhoneNumbers = () =>
    phoneNumber ? (
      <>
        {returnPhoneNumber(phoneNumber, 'tel')}
        {smsNumber}
      </>
    ) : (
      renderTollFreeDirectNumbers(tollFreeNumber, directNumber)
    );

  const phoneMessage =
    userCountryCode === 'US'
      ? renderTollFreeDirectNumbers(phoneNumber, directNumber)
      : renderNonUSPhoneNumbers();

  const localPhoneValidation = localPhone
    ? returnPhoneNumber(localPhone, 'tel')
    : phoneMessage;

  const messageWithPhones = replaceTokensWithComponents(
    t('CALL_US_DETAILS'),
    helpCenterEnabled ? phoneMessage : localPhoneValidation
  );

  return isCatCorp || selectedStore
    ? messageWithPhones
    : t('404_ERROR_ADD_DEALER_TEXT');
}

CallUsMessage.propTypes = {
  isCatCorp: PropTypes.bool,
  helpCenterEnabled: PropTypes.bool,
  tollFreeNumber: PropTypes.string,
  phoneNumber: PropTypes.string,
  directNumber: PropTypes.string,
  localPhone: PropTypes.string
};

export default CallUsMessage;
